<template>
  <div class="organizations" v-if="!!selectedOrganization">
    <div v-if="venuePending" class="p-pending">
      <BaseSpinner />
      <h3 class="organizations-title">Загружаем площадки</h3>
    </div>
    <div
      v-if="
        platformsOfSelectedOrganization.length &&
        !venuePending &&
        !selectedPlatform
      "
    >
      <h3 class="organizations-title">Выбрать из существующих адресов</h3>
      <button
        v-for="platform in displayedPlatforms"
        :key="platform.id"
        class="organizations-item"
        type="button"
        @click="
          $store.commit('requestPreparing/SET_SELECTED_PLATFORM', platform)
        "
      >
        <p class="organizations-name">
          {{ platform.name || "Площадка с ID: " + platform.id }}
        </p>
        <div class="buttons">
          <BaseButton
            class="mt-s"
            size="xs"
            shape="square"
            @click.stop="
              $store.commit('requestPreparing/SET_SELECTED_PLATFORM', platform)
            "
            >Выбрать</BaseButton
          >
          <BaseButton
            class="mt-s"
            size="xs"
            shape="square"
            theme="secondary"
            @click.stop="$emit('openModal', platform)"
            >Подробнее</BaseButton
          >
        </div>
      </button>
      <paginate
        v-if="platformPageCount > 1"
        v-model="platformsPage"
        :page-count="platformPageCount"
        container-class="pager"
        page-class="pager__page"
        next-class="pager__arrow pager__arrow--next"
        prev-class="pager__arrow pager__arrow--prev"
        prev-text=""
        next-text=""
        class="paginate"
      >
      </paginate>
    </div>
    <p
      v-if="
        !platformsOfSelectedOrganization.length &&
        !venuePending &&
        !selectedPlatform
      "
      class="text-center"
    >
      Все кружки Конкурса кружков размещаются на Карте кружков. Для отображения
      вашего кружка на карте, обозначьте точный адрес кружка.
    </p>
    <BaseButton
      v-if="!venuePending && !selectedPlatform"
      class="create"
      tag="router-link"
      :to="{ name: 'platform-create' }"
      >Уточнить данные кружка</BaseButton
    >
    <div
      v-if="organizations.length && selectedOrganization && selectedPlatform"
      class="organizations"
    >
      <h3 class="organizations-title">Выбранная площадка</h3>
      <div class="organizations-item selected">
        <p class="organizations-name">
          {{ selectedPlatform.name || "Площадка с ID: " + selectedPlatform.id }}
        </p>
        <BaseButton
          class="mt-s"
          size="xs"
          shape="square"
          @click="$store.commit('requestPreparing/SET_SELECTED_PLATFORM', null)"
          >отменить выбор</BaseButton
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PlatformSelect",
  data() {
    return {
      platformsPage: 1,
      pageLimit: 5,
    };
  },
  computed: {
    organizations() {
      return this.$store.state.requestPreparing.organizations;
    },
    selectedOrganization() {
      return this.$store.state.requestPreparing.selectedOrganization;
    },
    selectedPlatform() {
      return this.$store.state.requestPreparing.selectedPlatform;
    },
    venuePending() {
      return this.$store.state.requestPreparing.loadPending;
    },
    organizationsPlatforms() {
      return this.$store.state.requestPreparing.organizationsPlatforms;
    },
    platformsOfSelectedOrganization() {
      return this.organizationsPlatforms?.[this.selectedOrganization?.id] || [];
    },
    platformPageCount() {
      return Math.ceil(
        this.platformsOfSelectedOrganization.length / this.pageLimit
      );
    },
    displayedPlatforms() {
      const start = (this.platformsPage - 1) * this.pageLimit;
      const end = start + this.pageLimit;
      return [...this.platformsOfSelectedOrganization].slice(start, end);
    },
  },
};
</script>
<style lang="less" scoped>
.organizations {
  margin-top: @margin-xl;

  &-item {
    padding: 0;
    width: 100%;
    display: block;
    border: none;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    padding: 20px 30px;
    border-radius: @border-radius-xs;
    margin-bottom: @margin-s;
    box-shadow: 0 1px 2px rgba(45, 87, 96, 0.2);
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.02);
    }

    &.selected {
      border: 1px dashed @primary-color;
      cursor: default;
      &:hover {
        transform: scale(1);
      }
    }
  }
  &-title {
    font-size: @font-size-h4;
    line-height: @line-height-h4;
    text-align: center;
    font-weight: bold;
    margin-bottom: @margin-l;
  }
  &-name {
    font-weight: bold;
  }
}

.create {
  margin-left: auto;
  margin-right: auto;
  display: block !important;
  margin-top: 20px;
  max-width: fit-content;
}

.paginate {
  display: flex;
  justify-content: center;
  margin-top: @margin-l;
}

.p-pending {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;

  & span {
    margin-bottom: 3px;
  }

  .organizations-title {
    margin-bottom: 0;
  }
}

.buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: @screen-xs) {
  .organizations {
    &-title {
      font-size: @font-size-l;
      line-height: @line-height-l;
    }
  }
}
</style>
